import React from 'react';
import { Layout } from 'antd';
import RouteView from '../route';


export default function ContentView() {
    return (
        <Layout.Content
            style={{
                margin: '16px',
            }}
        >
            <div className='route-view'>
                <RouteView />
            </div>
        </Layout.Content>
    )
}
